const getRegion = function (rc) {
  if (rc) {
    const regionCodes = [
      { region: 'Dalarna', code: 'SE2321000180', footer: 'footer' },
      { region: 'Gävleborg', code: 'SE2321000198', footer: 'footer' },
      { region: 'Halland', code: 'SE2321000115', footer: 'footer' },
      { region: 'Jönköping', code: 'SE2321000057', footer: 'footer' },
      { region: 'Kalmar', code: 'SE2321000073', footer: 'footer' },
      { region: 'Kronoberg', code: 'SE2321000065', footer: 'footer' },
      { region: 'Skåne', code: 'SE162321000255', footer: 'footer' },
      { region: 'Stockholm/Gotland', code: 'SE2321000016', footer: 'footer' },
      { region: 'Uppsala', code: 'SE162321000024', footer: 'footer' },
      { region: 'Västerbotten', code: 'SE2321000222', footer: 'footer' },
      { region: 'Västernorrland', code: 'SE2321000206', footer: 'footer' },
      { region: 'Västmanland', code: 'SE2321000172', footer: 'footer' },
      { region: 'Västra Götaland', code: 'SE2321000131', footer: 'footer' },
      { region: 'Örebro', code: 'SE2321000164', footer: 'footer' },
      { region: 'Östergötland', code: 'SE2321000040', footer: 'footer' },
      { region: 'Blekinge', code: 'SE2321000081', footer: 'footer' },
      { region: 'Jämtland', code: 'SE2321000214', footer: 'footer' },
      { region: 'Norrbotten', code: 'SE2321000230', footer: 'footer' },
      { region: 'Södermanland', code: 'SE2321000032', footer: 'footer' },
      { region: 'Värmland', code: 'SE162321000156', footer: 'footer' },
      { region: 'Capio St Göran, Stockholm', code: 'SE5565189692', footer: 'footer' },
      { region: 'Carlanderska sjukhuset, Västra Götaland', code: 'SE8572002312', footer: 'footer' }
    ]
    const regionByCode = regionCodes.find(r => {
      return r.code === rc
    })
    return regionByCode.region
  }
}

export {
  getRegion
}



// WEBPACK FOOTER //
// ./src/plugins/regions.js